import { cn } from "../../lib/utils"

function Spinner({ className, size = "default" }) {
  const sizeClasses = {
    sm: "w-4 h-4 border-2",
    default: "w-8 h-8 border-3",
    lg: "w-12 h-12 border-4",
    xl: "w-16 h-16 border-4",
  }

  return (
    <div
      className={cn(
        "animate-spin rounded-full border-solid border-[#00599c] border-t-transparent",
        sizeClasses[size],
        className
      )}
      role="status"
      aria-label="Loading"
    >
      <span className="sr-only">Cargando...</span>
    </div>
  )
}

function LoadingOverlay({ message }) {
  return (
    <div className="flex flex-col items-center justify-center py-20">
      <Spinner size="lg" />
      {message && (
        <p className="mt-4 text-[#252a34]/60 text-sm font-medium">{message}</p>
      )}
    </div>
  )
}

export { Spinner, LoadingOverlay }
